export interface ActiveSession {
  id: string;
  last_access: Date;
  country: string;
  ip: string;
  browser: string | null;
  os: string | null;
  current: boolean;
}
